import { z } from "zod"

export const FEEDBACK_TEXT_MAX = 200

export const CallCaseSummaryFeedbackSchema = z.object({
  feedbackText: z
    .string()
    .trim()
    .min(1, "episodeOfCare.progressNote.anamnesis.callCaseSummaryFeedback.emptyError")
    .max(FEEDBACK_TEXT_MAX, "common.fieldErrorList.characterLimit"),
})

export type CallCaseSummaryFeedbackSchemaType = z.infer<typeof CallCaseSummaryFeedbackSchema>
